import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChildren } from '@angular/core';
import { BaseComponent } from '@shared/component/base/base.component';
import { YoutubeService, YoutubeVideoInterface } from 'taxtank-core';
import { YoutubeDialogComponent } from '@client/shared/components/youtube-dialog/youtube-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-video-gallery',
  templateUrl: './video-gallery.component.html',
  styleUrls: ['./video-gallery.component.scss'],
  standalone: false
})
export class VideoGalleryComponent extends BaseComponent implements OnInit {
  @ViewChildren('videoElement') videoElement: ElementRef;
  playlist: YoutubeVideoInterface[];
  selectedVideo: YoutubeVideoInterface;
  videoHeight = 235;

  constructor(private tutorialVideoService: YoutubeService,
              private cdr: ChangeDetectorRef,
              private dialog: MatDialog) {
    super();
  }

  ngOnInit(): void {
    this.tutorialVideoService.getTutorials(this.userService.getCacheFirst()).subscribe((playlist: YoutubeVideoInterface[]) => {
      this.playlist = playlist;
      this.selectedVideo = this.playlist[0];
    });
  }

  /**
   * @TODO might be used later
   */
  setHeight(): void {
    const proportion = 2;
    this.cdr.detectChanges();
    this.videoHeight = this.videoElement.nativeElement.offsetWidth / proportion;
  }

  selectVideo(video: YoutubeVideoInterface): void {
    this.selectedVideo = video;
  }

  openYoutubeDialog(videoId: string): void {
    this.dialog.open(YoutubeDialogComponent, {
      panelClass: 'dialog-medium',
      data: { videoId },
    });
  }
}
